import { useNavigate } from "react-router-dom";
import { ISuccessPopUpProps } from "./Interfaces";
import { Button, Col, Modal, Row } from "react-bootstrap";

export default function SuccessPopUp({
  showPopup,
  message,
  returnToHome = true,
  onClose
}: ISuccessPopUpProps) {
  const navigate = useNavigate();
  return (
    <Modal show={showPopup}>
      <Modal.Header>
        <Modal.Title>Success</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Col className="d-flex justify-content-center">
          <p>{message}</p>
        </Col>
        <Row>
          <Col className="d-flex justify-content-end">
            {returnToHome && <Button onClick={() => navigate("/", {})}>Home</Button>}
            {!returnToHome && <Button onClick={onClose}>Close</Button>}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}
